import initEvents from '../../../actions/events/initEvents';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { eventsSelector } from '@shared/store/slices/events.slice';
import { useAppSelector } from '../../../store/hooks';
import { useEffect } from 'react';

export default function useEvents() {
  const { channelsData } = useAppSelector(channelsSelector);
  const { lastModifiedDate, updateRate } = useAppSelector(eventsSelector);

  // Fetch events after all required data is obtained

  useEffect(() => {
    channelsData?.length && initEvents(true);
  }, [channelsData]);

  // Refresh events every 30 minutes

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const timeoutValue = lastModifiedDate
      ? lastModifiedDate - Date.now()
      : updateRate;

    if (timeoutValue) {
      timeout = setTimeout(() => {
        initEvents();
      }, timeoutValue);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [lastModifiedDate, updateRate]);
}
